import agencia from './page-agencia.js';
import { getDataFromUrl } from './generalFunctions';

const functions = new agencia()
functions.listarDestaquePronto();

const verifySearchParams = () => {
  const search = window.location.search;
  if (search) {
    const data = getDataFromUrl(search);
    const pagina = data.pagina ? data.pagina[0] : 1;
    functions.listarImoveis(pagina);
  } else {
    functions.listarImoveis();
  }
  functions.listarBanner();
}

verifySearchParams();



// WEBPACK FOOTER //
// ./src/assets/js/page-prontos.js